
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/real-estate-agent/[agentSlug]",
      function () {
        return require("private-next-pages/real-estate-agent/[agentSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/real-estate-agent/[agentSlug]"])
      });
    }
  